import { Injectable } from '@angular/core';
import { LocalStorageService } from './storage/local-storage.service';
import {
  CanActivate,
  CanLoad,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { EesDesService } from './ees-des.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private _localStorageService: LocalStorageService,
    public eesdesService:EesDesService
  ) {}
  urlList: any = [];
  arrayForSearch: any = [];
  bypassGuard: boolean = true;

  private logGuard(hook: string, path: string, allowed: boolean, reason: string) {
    const detail = {
      path: path,
      allowed: allowed,
      reason: reason,
      userId: this._localStorageService.getUserId(),
      role: this._localStorageService.getUserRole(),
      companyId: this._localStorageService.getEmpCompanyId(),
      autoLogout: localStorage.getItem('AutoLogout'),
      sessionCompanyId: sessionStorage.getItem('company_id')
    };
    if (allowed) {
      // console.log('[AuthGuard]', hook, detail);
    } else {
      // console.warn('[AuthGuard] blocked', hook, detail);
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.bypassGuard) {
      console.log('[AuthGuard] bypass canActivate', state && state.url ? state.url : '');
      return true;
    }
    let data: any = {};
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : {};
    const AutoLogout = localStorage.getItem('AutoLogout');
    const company_id = sessionStorage.getItem('company_id');
    const pageUrl = state && state.url ? state.url : '';
    if (AutoLogout == 'true' && (!company_id || company_id == undefined)) {
        this.logGuard('canActivate', pageUrl, false, 'AutoLogout is true and session company_id is missing');
        window.location.href = window.location.origin + '/#/login';
        return false;
        
    }
    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.logGuard('canActivate', pageUrl, false, 'user id is missing');
      this.toasterService.pop(
        'warning',
        'Warning',
        'You are not able access this page! Login First'
      );
      // this.router.navigateByUrl('/login');
      window.localStorage.clear();
      window.location.href = window.location.origin + '/#/login';

      return false;
    }
    if (this._localStorageService.getUserRole() == 'administrator') {
      this.logGuard('canActivate', pageUrl, true, 'administrator');
      return true;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = state.url ? state.url : '';
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (i.aurl == currenturl) {
            count++;
          }
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (j.aurl == currenturl) {
                count++;
              }
            }
          }
        }
        if (count <= 0 && currenturl != '/dashboard') {
          this.logGuard('canActivate', currenturl, false, 'menu does not include this url');
          this.toasterService.pop(
            'warning',
            'Warning',
            'you are not able access this page'
          );
          window.location.href = window.location.origin + '/#/dashboard';
          return false;
        }
      }
    }

    this.logGuard('canActivate', pageUrl, true, 'menu check passed or company is not selected');
    return true;
  }

  canLoad(route: Route): boolean {
    if (this.bypassGuard) {
      console.log('[AuthGuard] bypass canLoad', route && route.path ? route.path : '');
      return true;
    }
    let data: any = [];
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : [];
    const AutoLogout = localStorage.getItem('AutoLogout');
    const company_id = sessionStorage.getItem('company_id');

    const pagePath = route && route.path ? route.path : '';
    if (AutoLogout == 'true' && (!company_id || company_id == undefined)) {
          this.logGuard('canLoad', pagePath, false, 'AutoLogout is true and session company_id is missing');
          window.location.href = window.location.origin + '/#/login';
          return false;
    }

    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.logGuard('canLoad', pagePath, false, 'user id is missing');
      this.toasterService.pop(
        'warning',
        'Warning',
        'You are not able access this page! Login First'
      );
      window.localStorage.clear();
      window.location.href = window.location.origin + '/#/login';
      return false;
    }
    if (this._localStorageService.getUserRole() == 'administrator') {
      this.logGuard('canLoad', pagePath, true, 'administrator');
      return true;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = route.path;
      const parentUrls = route.data && route.data.parentUrls ? route.data.parentUrls : [];
      const urlsToMatch = parentUrls.length > 0 ? parentUrls : [`/${currenturl}`];
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (urlsToMatch.indexOf(i.aurl) !== -1) {
            count++;
          }
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (urlsToMatch.indexOf(j.aurl) !== -1) {
                count++;
              }
            }
          }
        }
        if (count <= 0 && currenturl != '/dashboard') {
          this.logGuard('canLoad', currenturl, false, 'menu does not include ' + urlsToMatch.join(', '));
          this.toasterService.pop(
            'warning',
            'Warning',
            'you are not able access this page'
          );
          window.location.href = window.location.origin + '/#/dashboard';
          return false;
        }
      }
    }
    this.logGuard('canLoad', pagePath, true, 'menu check passed or company is not selected');
    return true;
  }

  prepareSearchList(data) {
    const menuList: any = [];
    for (const x of data) {
      if (x.aurl != '#') {
        menuList.push(x.aurl);
      }
      if (x.submenu) {
        for (const d of x.submenu) {
          if (d.aurl != '#') {
            menuList.push(d.aurl);
          }
        }
      }
    }
    return menuList;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3185250503/src/src/app/shared/services/auth-guard.service.ts